import { useAuthStore } from '@/stores/authStore'
import { hasPermission, hasAnyPermission } from '@/lib/permissions'

/**
 * Check if the current user has a specific permission.
 */
export function useHasPermission(permission: string): boolean {
    const { user } = useAuthStore()
    if (!user?.role) return false
    return hasPermission(user.role, permission)
}

/**
 * Check if the current user has any of the given permissions.
 */
export function useHasAnyPermission(permissions: string[]): boolean {
    const { user } = useAuthStore()
    if (!user?.role) return false
    return hasAnyPermission(user.role, permissions)
}

/**
 * Get the current user's role.
 */
export function useRole(): string | undefined {
    const { user } = useAuthStore()
    return user?.role
}

/**
 * Check if current user is a super admin type (SUPER_ADMIN, ADMIN, MODERATOR, VIEWER).
 */
export function useIsSuperAdmin(): boolean {
    const { user } = useAuthStore()
    return ['SUPER_ADMIN', 'ADMIN', 'MODERATOR', 'VIEWER'].includes(user?.role || '')
}
